import Vue from 'vue'
import Router from 'vue-router'
import Restaurant from '../components/restaurant.vue'
import Advertisement from '../components/advertisement.vue'
import Detail from '../components/detail.vue'
import Event from '../components/event.vue'
import AddEqu from '../components/addequ.vue'
import EditEqu from '../components/editequ.vue'
import EditUser from '../components/edituser.vue'
import AddUser from '../components/adduser.vue'
import Admin from '../components/admin.vue'
import Carrepair from '../components/carrepair.vue'
import Dust from '../components/dust.vue'
import Detail2 from '../components/detail2.vue'
import EventSetting from '../components/eventsetting.vue'
import EquList from '../components/equlist.vue'
import EventList from "../components/eventlist.vue"
import DailyReport from "../components/dailyreport.vue"
import Event2 from "../components/event2.vue"
import EventDaily from "../components/eventdaily.vue"
import AddMiniUser from '../components/addminiuser.vue'
import MiniAdmin from '../components/miniadmin.vue'
import Error from "../components/error.vue"

Vue.use(Router)
export default new Router({
	routes:[
		{
			path:'/restaurant',
			component:Restaurant
		},
		{
			path:'/advertisement',
			component:Advertisement
		},
		{
			path:'/carrepair',
			component:Carrepair
		},
		{
			path:'/dust',
			component:Dust
		},
		{
			path:'/detail',
			component:Detail
		},
		{
			path:'/event',
			component:Event
		},
		{
			path:'/event2',
			component:Event2
		},
		{
			path:'/addequ',
			component:AddEqu
		},
		{
			path:'/editequ',
			component:EditEqu
		},
		{
			path:'/edituser',
			component:EditUser
		},
		{
			path:'/adduser',
			component:AddUser
		},
		{
			path:'/admin',
			component:Admin
		},
		{
			path:'/detail2',
			component:Detail2
		},
		{
			path:'/eventsetting',
			component:EventSetting
		},
		{
			path:'/equlist',
			component:EquList
		},
		{
			path:'/eventlist',
			component:EventList
		},
		{
			path:'/dailyReport',
			component:DailyReport
		},
		{
			path:'/eventDaily',
			component:EventDaily
		},
		{
			path:'/error',
			component:EventDaily
		}
		,
		{
			path:'/addMiniUser',
			component:AddMiniUser
		},
		{
			path:'/miniAdmin',
			component:MiniAdmin
		}
	],
	mode:'history'
})